import React from 'react';
import { Badge, Spinner } from '../../../components/app2';

/**
 * Cómo se ve cada estado de una sincronización.
 *
 * Los estados son los del orquestador del servidor. Se nombran en el idioma del
 * usuario, no en el del SAT: a nadie le sirve "sat_status_code 2".
 */

export const ESTADOS = {
  encolada: { tone: 'neutral', icon: 'schedule', label: 'En espera', vivo: true },
  solicitud_aceptada: { tone: 'brand', icon: 'send', label: 'Pedida al SAT', vivo: true },
  en_proceso: { tone: 'brand', icon: 'autorenew', label: 'El SAT la prepara', vivo: true },
  lista_para_descargar: { tone: 'warn', icon: 'cloud_download', label: 'Lista para descargar', vivo: true },
  descargando: { tone: 'brand', icon: 'downloading', label: 'Descargando', vivo: true },
  terminada: { tone: 'ok', icon: 'task_alt', label: 'Completada' },
  failed: { tone: 'danger', icon: 'error', label: 'Fallida' },
  rejected: { tone: 'danger', icon: 'block', label: 'Rechazada' },
  expirada: { tone: 'warn', icon: 'timer_off', label: 'Paquete vencido' },
  cancelada: { tone: 'neutral', icon: 'cancel', label: 'Cancelada' },
};

export const esVivo = (status) => Boolean(ESTADOS[status]?.vivo);

const EstadoSync = ({ status, conSpinner = true }) => {
  const e = ESTADOS[status] || { tone: 'neutral', icon: 'help', label: status || 'Desconocido' };
  return (
    <Badge tone={e.tone} icon={e.icon}>
      {e.label}
      {e.vivo && conSpinner ? <Spinner size={12} style={{ marginLeft: 6 }} /> : null}
    </Badge>
  );
};

export default EstadoSync;
